// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import Backbone from 'backbone';
import reactUpdate from 'immutability-helper';
import React from 'react';
import ReactDOM from 'react-dom';
import {debounce} from 'ts-debounce';

import DataConnector from 'connect/DataConnector';
import * as CrisprConstants from 'constants/CRISPRConstants';
import HRTemplateTabState from 'molbio/crispr/hr-template/HRTemplateTabState';
import OrganismStore from 'molbio/genome/organism/OrganismStore';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import ModalAnchor from 'ui-library/ModalAnchor';

import HRTemplateStore, {HRTemplateDesignState} from './HRTemplateStore';
import IntroduceEditsStep from './IntroduceEditsStep';
import RemoveTargetSiteStep from './RemoveTargetSiteStep';
import SelectArmsStep from './SelectArmsStep';
import SettingsModal from './SettingsModal';
import SummaryStep from './SummaryStep';

const {HR_TEMPLATE_STEP, HR_TEMPLATE_TAB_ID} = CrisprConstants;

interface HRTemplateOptionsProps {
  allowEdits: boolean;
  sequenceId: string;
  circular: boolean;
}

interface HRTemplateOptionsState {
  showSettingsModal: boolean;
}

class HRTemplateOptions extends React.Component<HRTemplateOptionsProps, HRTemplateOptionsState> {
  override state: HRTemplateOptionsState = {
    showSettingsModal: false,
  };

  override render(): JSX.Element {
    return (
      <ul className="nav navbar-nav form-inline">
        <li className="pull-right">
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            size={ButtonSize.MINI}
            disabled={!this.props.allowEdits || this.props.circular}
            onClick={() => {
              this.setState({showSettingsModal: true});
            }}
            text="Settings"
          />
        </li>
        <ModalAnchor open={this.state.showSettingsModal}>
          <SettingsModal
            sequenceId={this.props.sequenceId}
            onRequestClose={() => {
              this.setState({showSettingsModal: false});
            }}
          />
        </ModalAnchor>
      </ul>
    );
  }
}

/* eslint-disable @typescript-eslint/unbound-method */
class HRTemplateOptionsView extends Backbone.View<HRTemplateTabState> {
  static initClass(): void {
    this.prototype.className = 'navbar';
  }

  override initialize(options: Backbone.ViewOptions<HRTemplateTabState>): void {
    this.listenTo(
      this.model.sequence(),
      'change:writable change:permissions change:currentVersion',
      this.render
    );
    this.listenTo(this.model.sequence()._sequence(), 'change:locked', this.render);
  }

  override render(): this {
    renderToDOM(
      <HRTemplateOptions
        sequenceId={this.model.sequence().id}
        allowEdits={this.model.sequence().allowFeatureEdits({tabId: HR_TEMPLATE_TAB_ID})}
        circular={this.model.sequence().circular()}
      />,
      this.el
    );
    return this;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-module-boundary-types
  override remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
/* eslint-enable @typescript-eslint/unbound-method */
HRTemplateOptionsView.initClass();

class HRTemplateTabConnector extends DataConnector<HRTemplateTabProps, HRTemplateDesignState> {
  override shouldSubscribeToRedux = false;
  override stores = [HRTemplateStore, OrganismStore];

  enhanceProps(): HRTemplateDesignState {
    let designState = this.hrTemplateStore().getDesignState(this.props.sequenceId)! || {};
    if (designState.organismId != null) {
      designState = reactUpdate(designState, {
        codonUsage: {$set: this.organismStore().getCodonUsage(designState.organismId)},
      });
    }
    return designState;
  }
}

interface HRTemplateTabProps {
  allowEdits: boolean;
  tabId: string;
  sequenceId: string;
  selection: {
    start: number;
    end: number | null;
  };
  circular: boolean;
}
function HRTemplateTab(props: HRTemplateTabProps & HRTemplateDesignState): JSX.Element {
  if (!props.allowEdits) {
    return <div>HR Template design is disabled on read-only sequences.</div>;
  } else if (props.circular) {
    return (
      <div>
        <p>HR Template design is not yet available for circular sequences.</p>
        <p>
          {'To change a sequence from circular to linear, click the '}
          <BenchlingIcon icon="info-circle" />
          {' in the right sidebar.'}
        </p>
      </div>
    );
  } else {
    return (
      <div>
        {(() => {
          switch (props.step) {
            case HR_TEMPLATE_STEP.INTRODUCE_EDITS:
              return (
                <IntroduceEditsStep
                  sequence={props.sequence!}
                  originalBases={props.savedVersions[HR_TEMPLATE_STEP.INTRODUCE_EDITS].bases}
                />
              );
            case HR_TEMPLATE_STEP.SELECT_ARMS:
              return (
                <SelectArmsStep
                  sequence={props.sequence!}
                  savedVersions={props.savedVersions}
                  armRegion={props.armRegion}
                  resettingToVersion={props.resettingToVersion}
                  modifyingSequence={props.modifyingSequence}
                  isHRTemplateLoading={props.isHRTemplateLoading}
                  selection={props.selection}
                />
              );
            case HR_TEMPLATE_STEP.REMOVE_TARGET_SITE:
              return (
                <RemoveTargetSiteStep
                  sequence={props.sequence!}
                  pam={props.pam}
                  guide={props.guide}
                  errorMessage={props.errorMessage}
                  warningMessage={props.warningMessage}
                  targetSite={props.targetSite}
                  columns={props.columns}
                  resettingToVersion={props.resettingToVersion}
                  modifyingSequence={props.modifyingSequence}
                  isHRTemplateLoading={props.isHRTemplateLoading}
                  codonUsage={props.codonUsage}
                />
              );
            case HR_TEMPLATE_STEP.SUMMARY:
              return (
                <SummaryStep
                  sequence={props.sequence!}
                  pam={props.pam}
                  targetSite={props.targetSite}
                  savedVersions={props.savedVersions}
                  guide={props.guide}
                  armRegion={props.armRegion}
                  resettingToVersion={props.resettingToVersion}
                  isHRTemplateLoading={props.isHRTemplateLoading}
                  columns={props.columns}
                />
              );
            default:
              return null;
          }
        })()}
      </div>
    );
  }
}

const ConnectedHRTemplateTab = HRTemplateTabConnector.connect(HRTemplateTab);

/* eslint-disable @typescript-eslint/unbound-method */
class HRTemplateTabView extends Backbone.View<HRTemplateTabState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab-reset';
  }

  override initialize(options: Backbone.ViewOptions<HRTemplateTabState>): void {
    const sequence = this.model.sequence();
    const _sequence = sequence._sequence();
    this.listenTo(sequence, 'change:writable change:permissions change:currentVersion', this.render);
    this.listenTo(_sequence, 'change:bases change:circular change:startIndex change:locked', this.render);
    this.listenTo(_sequence.translations(), 'add remove change', this.render);
    this.listenTo(sequence.selection(), 'change:start change:end', debounce(this.render, 250));
    this.listenTo(sequence.get('versions'), 'reloaded sync', this.render);
  }

  override render(): this {
    const sequence = this.model.sequence();
    renderToDOM(
      <ConnectedHRTemplateTab
        sequenceId={sequence.id}
        tabId={this.model.id}
        allowEdits={sequence.allowResidueEdits({tabId: HR_TEMPLATE_TAB_ID})}
        selection={{start: sequence.selection().start(), end: sequence.selection().end()}}
        circular={sequence.circular()}
      />,
      this.el
    );
    return this;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-module-boundary-types
  override remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
/* eslint-enable @typescript-eslint/unbound-method */
HRTemplateTabView.initClass();

export {HRTemplateOptionsView as OptionsView, HRTemplateTabView as TabView};
